(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ApprovalPolicyDeleteController',ApprovalPolicyDeleteController);

    ApprovalPolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApprovalPolicy', 'GlobalValues', 'ScreenLog','$scope'];

    function ApprovalPolicyDeleteController($uibModalInstance, entity, ApprovalPolicy, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.approvalPolicyDTO = entity;
    	//ScreenLog.screenLog({'entityName': 'ApprovalProcess', 'entityRecordId': vm.approvalPolicyDTO.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	ApprovalPolicy.delete({"orgId":GlobalValues.getOrgId(),id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
